<div [ngClass]="{ 'noauth': !isAuthenticated && !isLogin }" class="main-container">
  <app-header class="main-header"></app-header>
  <div class="main-content" [@routeAnimation]="getAnimationData()">
    <router-outlet />
  </div>
  <app-footer class="main-footer"></app-footer>
</div>